module.exports = __webpack_public_path__ + "img/part2-1.531082c8.jpg";